import React from "react";
import { NavLink } from "react-router-dom";
import { Icon, Image } from "semantic-ui-react";
import styled from "styled-components";
import { Paths } from "../../Constants";
import PeopleActive from "../../assets/follow-sel.png";
import PeopleInactive from "../../assets/follow.png";
import SettingsActive from "../../assets/config-sel.png";
import SettingsInactive from "../../assets/config.png";
import MyTestsActive from "../../assets/tests-sel.png";
import MyTestsInactive from "../../assets/tests.png";

const TabButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: stretch;
  margin-top: 20px;
  border-botton-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: black;
  padding-bottom: 15px;
`;

const WindowTabButton = styled(NavLink)`
  //cursor: ${(props) => (props.safewindow ? "" : "pointer")};
  flex-grow: 1;
  text-align: center;
`;

const TestsTabButton = styled(NavLink)`
  //cursor: ${(props) => (props.mytests ? "" : "pointer")};
  flex-grow: 1;
  text-align: center;
  flex-direction: row;
  display: flex;
  justify-content: center;
`;

const PeopleTabButton = styled(NavLink)`
  //cursor: ${(props) => (props.people ? "" : "pointer")};
  flex-grow: 1;
  text-align: center;
  flex-direction: row;
  display: flex;
  justify-content: center;
`;

const SettingsTabButton = styled(NavLink)`
  //cursor: ${(props) => (props.settings ? "" : "pointer")};
  flex-grow: 1;
  text-align: center;
  flex-direction: row;
  display: flex;
  justify-content: center;
`;

const TabBar = (props) => {
  return (
    <TabButtonWrapper>
      <WindowTabButton to={Paths.SAFE_WINDOW}>
        {props.safewindow ? (
          <Icon name="calendar outline" color="blue" size="big" />
        ) : (
          <Icon name="calendar outline" color="black" size="big" />
        )}
      </WindowTabButton>
      <TestsTabButton to={Paths.MY_TESTS}>
        {props.mytests ? (
          <Image src={MyTestsActive} />
        ) : (
          <Image src={MyTestsInactive} />
        )}
      </TestsTabButton>
      <PeopleTabButton to={Paths.PEOPLE}>
        {props.people ? (
          <Image src={PeopleActive} />
        ) : (
          <Image src={PeopleInactive} />
        )}
      </PeopleTabButton>
      <SettingsTabButton to={Paths.SETTINGS}>
        {props.settings ? (
          <Image src={SettingsActive} />
        ) : (
          <Image src={SettingsInactive} />
        )}
      </SettingsTabButton>
    </TabButtonWrapper>
  );
};

export default TabBar;
